import { useAct } from 'FlowBuilder/store'
import LiquidValidator from 'Shared/components/LiquidValidator/LiquidValidator'
import { useLanguagesData } from 'FlowBuilder/hooks/useLanguageFlow'

export default function EditActionTemplate() {
  const act = useAct()
  const id = useSel(s => s.local.modal.actionTemplateId)
  const actionId = useSel(s => s.local.modal.actionId)
  const { name, subject, body, language } = useSel(s => id ? s.actionTemplates.entities[id] : { name: '', subject: '', body: '', language: '' })
  const [localName, setLocalName] = useState(name)
  const [localSubject, setLocalSubject] = useState(subject)
  const [localBody, setLocalBody] = useState(body)
  const [validLiquidSubject, setValidLiquidSubject] = useState(false)
  const [validLiquidBody, setValidLiquidBody] = useState(false)
  const mergeTags = useSel(s => s.builder.mergeTags || [])
  const { editableLanguagesData } = useLanguagesData()
  const [localLanguage, setLocalLanguage] = useState(language)

  const label = id ? "Update" : "Add"
  const buttonDisabled = !localName || !validLiquidBody || !validLiquidSubject

  function onUpdate() {
    const payload = {
      name: localName,
      subject: localSubject,
      body: localBody,
      language: localLanguage,
    }

    if (id) {
      act.actionTemplates.upsert(id, payload)
    } else {
      act.actionTemplates.add({ ...payload, actionId, active: true })
    }

    act.local.closeModal()
  }

  return <div>
    <div className='row'>
      <div className='column remaining'>
        <div className='field margin-bottom'>
          <label className='bold'>Template name</label>
          <input
            type='text'
            value={localName}
            onChange={e => setLocalName(e.target.value)}
            className='full-width margin-top'
          />
        </div>

        <div className='field margin-bottom'>
          <label className='bold'>Subject line</label>
          <input
            type='text'
            value={localSubject}
            onChange={e => setLocalSubject(e.target.value)}
            className='full-width margin-top'
          />
          <LiquidValidator
            value={localSubject}
            lineSplitTags={true}
            availableTags={mergeTags}
            setValid={setValidLiquidSubject}
            className='margin-top'
          />
        </div>

        <div className='field'>
          <label className='bold'>Content</label>
          <div className='margin-top'>
            <textarea
              value={localBody}
              onChange={e => setLocalBody(e.target.value)}
              rows={6}
              className='full-width'
            />
          </div>
          <LiquidValidator
            value={localBody}
            lineSplitTags={true}
            availableTags={mergeTags}
            setValid={setValidLiquidBody}
            className='margin-top'
          />
        </div>
        { editableLanguagesData && Object.values(editableLanguagesData).length > 1 && <div className='field margin-top'>
          <label className='bold'>Language</label>
          <select value={localLanguage} onChange={e => setLocalLanguage(e.target.value)} className='margin-top'>
            <option value={''}>
              Global (All Languages)
            </option>
            { Object.entries(editableLanguagesData).map(([lang, data]) => (
              <option key={lang} value={lang}>
                {data.flag} {data.name}
              </option>
            )) }
          </select>
        </div>}

        <div>
          <button className='button primary margin-top' onClick={onUpdate} disabled={buttonDisabled}>{label}</button>
        </div>
      </div>
    </div>
  </div>
}



